import Crud from './crud'
import { export_list } from '@/commons/hpod';
var FileSaver = require('file-saver');
var crud = new Crud('orders', 'đơn hàng');

const state = {
    ...crud.state,
    new: {},
    sale: {},
    selected: {
        id: 0
    }
};
const getters = {
    ...crud.getters,
};
const actions = {
    ...crud.actions,
    export_order({ commit }, param) {
        commit("setLoading", { loading: true });
        export_list("orders", res => {
            commit("setLoading", { loading: false });
            var blob = new Blob([res.data], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"});
            FileSaver.saveAs(blob, `DanhSachDonHang_${new Date().getTime()}.xlsx`);
        }, param, this.state.authentication.token, 'export');
    },
};
const mutations = {
    ...crud.mutations,
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};